export const convertToHuman = (value) => {
    const currentDate = new Date();
    const date = new Date(value);
    let interval = (currentDate.getTime() - date.getTime()) / 1000;
    if (interval < 60) {
        return {
            key: "just_now"
        };
    }
    interval = interval / 60;
    if (interval < 60) { // less than 1 hour
        return {
            key: "minutes_ago",
            interval: Math.floor(interval),
        };
    }
    interval = interval / 60;
    if (interval < 24) { // less than 1 day
        return {
            key: "hours_ago",
            interval: Math.floor(interval),
        };
    }
    interval = interval / 24;
    if (interval < 30) { // less than 1 month
        return {
            key: "days_ago",
            interval: Math.floor(interval),
        };
    }
    interval = interval / 30;
    if (interval < 12) { // less than 1 year
        return {
            key: "months_ago",
            interval: Math.floor(interval),
        };
    }
    interval = interval / 12;
    return {
        key: "years_ago",
        interval: Math.floor(interval),
    };
};
export const formattingResponseTime = (second) => {
    let interval = Math.floor(second / 60);
    if (interval <= 1) {
        return {
            key: "less_than_minute"
        };
    }
    if (interval < 60) {
        return {
            key: "minutes_duration",
            interval
        };
    }
    interval = Math.floor(interval / 60);
    if (interval < 24) {
        return {
            key: "hours_duration",
            interval
        };
    }
    return {
        key: "days"
    };
};
